import { ref } from '../config/firebase';

export function getTosUpdatedDate() {
    return ref.child('/VERSION/tosUpdated').once('value')
        .then((tosSnapshot) => tosSnapshot.val());
}



// WEBPACK FOOTER //
// ./src/firebase/tos.js